<template>
<!-- 公告详情 -->
  <div class="home">
      <Header></Header>
      <div class="main">
        <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>正文</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 style="text-align:center;font-size: 28px;line-height: 40px;margin-top:20px;">{{List.title}}</h1>
    <div style="margin:20px 0;"><span style="font-size:12;color:#999;">发布时间：</span> <span>{{List.create_time}}</span></div>
    <div class="content" v-html="List.desc"></div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue"
import Footer from "../components/Footer.vue"
import Axios from "axios"
export default {
    metaInfo(){
     return{
        title: '公告详情_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
    name:"NoticeDetails",
    data(){
        return{
                List:''
        }
    },
    components:{
        Header,
        Footer
    },
    methods:{

    },
        mounted(){
            let id = this.$route.query.id;  
            ////console.log(id)  ;
             Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/announcement/detail",
      params: {
          id:id
      },
      headers: {
          token: localStorage.getItem("token"),
        },
    }).then((res) => {
        ////console.log(res);
        this.List=res.data.data;
    });
        }
}
</script>

<style scoped>
.home {
  background: #f5f7f9;
}
.main{
    width:800px;
    min-height:800px;
    margin:20px auto;
    background:#fff;
    padding:20px;
}
/deep/ .content img{
    max-width:800px;
}
</style>